import * as React from "react";

function SvgUpLeft(props) {
  return <svg data-name="Calque 1" viewBox="0 0 26.77 15.5" width="1em" height="1em" {...props}><path d="M26 6.54a1.1 1.1 0 010 2.08l-5.55 3.23-5.56 3.23a4 4 0 01-3.58 0 2.1 2.1 0 01-.5-.4L.26 2.14C-.79.88 1.48-.44 3.64.14l21.68 6.08a2.79 2.79 0 01.68.32z" fill="#153042" /></svg>;
}

export default SvgUpLeft;